import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from '@ticketswap/solar'
import EventWarningAlert from '~/components/EventWarningAlert'
import Money from '~/utils/money'
import { decodeGlobalId } from '~/utils/id'
import visit from '~/utils/visit'
import { createMarkup, getLinkProps } from '~/utils'
import { moneyPropTypes } from '~/graphql/fragments/money'

const PurchaserAlerts = ({
  t,
  isBundledTickets,
  bundledTicketsAmount,
  error,
  event,
  totalPriceWithTransactionFee,
  query,
  quantity,
  locale,
  listing,
  numberOfTicketsFromListingInUsersCart,
  showEditOptions,
  cartHref,
}) => {
  const previousPrice = query?.amount && parseFloat(query.amount)

  return (
    <>
      {isBundledTickets && (
        <Alert>
          {t('listing:purchaser.bundledTickets.alert', {
            amount: bundledTicketsAmount,
          })}
        </Alert>
      )}

      <EventWarningAlert event={event} />

      {error && <Alert variant="error">{error.message}</Alert>}

      {previousPrice && previousPrice !== totalPriceWithTransactionFee.amount && (
        <Alert variant={previousPrice > totalPriceWithTransactionFee.amount ? 'info' : 'warning'}>
          {t(
            `listing:purchaser.ticketPriceAlerts.${
              previousPrice > totalPriceWithTransactionFee.amount ? 'lowerPrice' : 'higherPrice'
            }`,
            {
              oldPrice: query?.price,
              newPrice: new Money(totalPriceWithTransactionFee, locale).multiply(quantity).format(),
            }
          )}
        </Alert>
      )}

      {showEditOptions && (
        <Alert
          action={{
            label: t('listing:purchaser.editOptions.button'),
            onClick: () => {
              visit(
                getLinkProps('PROFILE_FOR_SALE_LISTING', {
                  id: decodeGlobalId(listing.id),
                  hash: listing.hash,
                })
              )
            },
          }}
        >
          {t('listing:purchaser.editOptions.text')}
        </Alert>
      )}

      {numberOfTicketsFromListingInUsersCart > 0 && (
        <Alert
          variant="success"
          action={{
            label: t('listing:purchaser.cartInfo.button'),
            onClick: () => visit({ href: cartHref }),
          }}
        >
          <span
            dangerouslySetInnerHTML={createMarkup(
              t('listing:purchaser.cartInfo.text', {
                count: numberOfTicketsFromListingInUsersCart,
              }),
              { renderInline: true }
            )}
          />
        </Alert>
      )}
    </>
  )
}

PurchaserAlerts.propTypes = {
  t: PropTypes.func.isRequired,
  isBundledTickets: PropTypes.bool,
  bundledTicketsAmount: PropTypes.number,
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }),
  totalPriceWithTransactionFee: moneyPropTypes,
  query: PropTypes.object,
  quantity: PropTypes.number,
  locale: PropTypes.string,
  listing: PropTypes.shape({
    id: PropTypes.string.isRequired,
    hash: PropTypes.string.isRequired,
  }),
  numberOfTicketsFromListingInUsersCart: PropTypes.number,
  showEditOptions: PropTypes.bool,
  cartHref: PropTypes.string,
}

export default PurchaserAlerts
